import RichTextInline from 'components/shared/RichTextInline/RichTextInline';
import { InlineTextStyle } from 'types/constants';
import { InlineStyledTextProps } from './types';

// Additive successor to ThemedText/UnlockedText: one inline entry whose `textStyle`
// picks the treatment. Themed Color reuses `themedText`'s colorway-derived color and
// Unlocked Font reuses `unlockedText`'s typeface — but rendering goes through
// RichTextInline (not a bare documentToReactComponents) so the links and nested inline
// entries `content` permits actually render. The style class sits on a wrapping span:
// color, font-family, and font-weight all inherit, so this is visually identical to the
// legacy paragraph-level span.
export const InlineStyledText = ({ content, textStyle }: InlineStyledTextProps) => {
  if (!content) return null;

  let className: string | undefined;

  switch (textStyle) {
    case InlineTextStyle.ThemedColor:
      className = 'text-(--themed-text-color)';
      break;
    case InlineTextStyle.UnlockedFont:
      className = 'font-unlocked font-normal';
      break;
  }

  return (
    <span className={className}>
      <RichTextInline inline={content} />
    </span>
  );
};
